import { render, staticRenderFns } from "./NotificationHandsUp.vue?vue&type=template&id=3286fb4b"
import script from "./NotificationHandsUp.vue?vue&type=script&lang=js"
export * from "./NotificationHandsUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3286fb4b')) {
      api.createRecord('3286fb4b', component.options)
    } else {
      api.reload('3286fb4b', component.options)
    }
    module.hot.accept("./NotificationHandsUp.vue?vue&type=template&id=3286fb4b", function () {
      api.rerender('3286fb4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notifications/RoomNotifications/NotificationHandsUp.vue"
export default component.exports